
    export default {
        inject: {
            '$webAnalytics':  {
                default: {
                    track (name, options) {
                        console.warn(
                            'OutgoingAffiliate: $webAnalytics not provided by app - cant inject',
                        );
                        /* istanbul ignore next */
                        if (typeof options.callback === 'function') options.callback();
                    },
                },
            },
        },

        props: {
            affiliateId: {
                type: String,
                required: true,
            },
            routePath: {
                type: String,
                default: '/redirect_to_affiliate',
            },
        },

        computed: {
            href () {
                return `${this.routePath}?affiliate_id=${this.affiliateId}`;
            },
        },

        methods: {
            trackAndGo (event) {
                const
                    target = this.$attrs.target,
                    {
                        affiliateId,
                        $webAnalytics,
                        href,
                    } = this;

                // Allow default behavior when we are opening in a new window.
                // This happens when target is `_blank`, or the user presses
                // CTRL+click, CMD+click, or middle click.
                /* istanbul ignore next */
                if (
                    target === '_blank' ||
                    event.ctrlKey || event.metaKey || event.button == 1
                ) {
                    $webAnalytics.track(
                        'Exit',
                        {
                            category: 'Affiliate',
                            label: affiliateId,
                            value: 1,
                        },
                    );
                    return true;
                }
                else {
                    $webAnalytics.track(
                        'Exit',
                        {
                            category: 'Affiliate',
                            label: affiliateId,
                            value: 1,
                            callback: () => {
                                try {
                                    switch (target) {
                                        case '_top':
                                            window.top.location.href = href;
                                            break;
                                        case '_parent':
                                            window.parent.location.href = href;
                                            break;
                                        default:
                                            window.location.href = href;
                                    }
                                }
                                catch (e) {
                                    // jsdom doesn't support navigation globals, so it throws
                                    // a TypeError https://github.com/facebook/jest/issues/5277
                                    if (e instanceof TypeError) return;
                                    throw e;
                                }
                            },
                        },
                    );

                    event.preventDefault();
                    return false;
                }
            },
        },
    };
